
/**
 * Himalume Theme JS — lean, deferred, mobile-safe
 */
(function() {
  'use strict';
 
  document.addEventListener('DOMContentLoaded', function() {
 
    // ── Smooth scroll for anchor links ──────────────────────
    document.addEventListener('click', function(e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      var target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
 
    // ── Passive scroll listeners (better performance) ───────
    // (Individual sections handle their own scroll effects)
 
    // ── Ripple effect for buttons only ──────────────────────
    var rippleSelector = 'button, input[type="submit"], input[type="button"], a[class*="btn" i], a[class*="button" i], a[class*="cta" i], .pl-cta a, .sg-cta a, [role="button"]';
 
    document.addEventListener('pointerdown', function(e) {
      var btn = e.target.closest(rippleSelector);
      if (!btn) return;
 
      btn.classList.add('hm-ripple-host');
 
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      var span = document.createElement('span');
      span.className = 'hm-ripple-span';
      span.style.width = span.style.height = size + 'px';
      span.style.left = (e.clientX - rect.left - size / 2) + 'px';
      span.style.top = (e.clientY - rect.top - size / 2) + 'px';
 
      btn.appendChild(span);
      span.addEventListener('animationend', function() {
        span.remove();
      });
    });
 
  });
 
})();
 